module.exports = __webpack_public_path__ + "static/media/richee.9c1d4335.jpg";